import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GridColDef,
  GridPaginationModel,
  GridRowSelectionModel,
  GridValidRowModel
} from '@mui/x-data-grid';

const checkboxSelectionColumn: GridColDef = {
  field: GRID_CHECKBOX_SELECTION_FIELD,
  width: 52,
  sortable: false,
  renderHeader: () => null
};

interface Params<RowType extends GridValidRowModel> {
  columns: GridColDef<RowType>[];
  rowSelectionModel: GridRowSelectionModel;
  onRowSelectionModelChange: (rowSelectionModel: GridRowSelectionModel) => void;
  onPaginationModelChange: (paginationModel: GridPaginationModel) => void;
}

export const getRowSelectionDataGridProps = <RowType extends GridValidRowModel>({
  columns,
  rowSelectionModel,
  onRowSelectionModelChange,
  onPaginationModelChange
}: Params<RowType>) => ({
  columns: [checkboxSelectionColumn, ...columns],
  checkboxSelection: true,
  rowSelection: true,
  rowSelectionModel,
  onRowSelectionModelChange,
  onPaginationModelChange,
  disableRowSelectionExcludeModel: true,
  disableMultipleRowSelection: false,
  keepNonExistentRowsSelected: true,
  sortingOrder: ['asc', 'desc'] as const
});
